import { X } from "lucide-react";

const FilterPanel = ({ tags, lines, selectedTags, onToggleTag, selectedCategory, onCategoryChange, onClear }) => {
  return (
    <div data-testid="filter-panel" className="space-y-8">
      <div>
        <h3 className="font-mono-tech text-xs uppercase tracking-widest text-emerald-400 mb-3">Línea de producto</h3>
        <div className="flex flex-col gap-1">
          <button
            onClick={() => onCategoryChange("")}
            data-testid="filter-line-all"
            className={`text-left rounded-lg px-3 py-2 text-sm transition-colors ${!selectedCategory ? "bg-emerald-500/15 text-emerald-400 font-medium" : "hover:bg-secondary text-muted-foreground"}`}
          >
            Todas las líneas
          </button>
          {lines.map((l) => (
            <button
              key={l.id}
              onClick={() => onCategoryChange(l.id)}
              data-testid={`filter-line-${l.id}`}
              className={`text-left rounded-lg px-3 py-2 text-sm transition-colors ${selectedCategory === l.id ? "bg-emerald-500/15 text-emerald-400 font-medium" : "hover:bg-secondary text-muted-foreground"}`}
            >
              {l.short}
            </button>
          ))}
        </div>
      </div>

      <div>
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-mono-tech text-xs uppercase tracking-widest text-emerald-400">Etiquetas de salud</h3>
          {(selectedTags.length > 0 || selectedCategory) && (
            <button data-testid="clear-filters-btn" onClick={onClear} className="flex items-center gap-1 text-[11px] text-muted-foreground hover:text-destructive transition-colors">
              <X className="h-3 w-3" /> Limpiar
            </button>
          )}
        </div>
        <div className="flex flex-wrap gap-2">
          {tags.map((t) => {
            const active = selectedTags.includes(t);
            return (
              <button
                key={t}
                data-testid={`tag-filter-${t}`}
                onClick={() => onToggleTag(t)}
                className={`rounded-full border px-3 py-1.5 text-xs font-medium transition-all ${
                  active
                    ? "border-emerald-500 bg-emerald-500/20 text-emerald-300"
                    : "border-border bg-secondary/40 text-muted-foreground hover:border-emerald-500/50 hover:text-emerald-400"
                }`}
              >
                {t}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;
